export const objectIsFalsy = (object: {}) => Object.values(object).filter((value) => value !== undefined || null).length === 0;
